import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://it-service.wanorn.com/backend/api/'

const token = localStorage.getItem('token')

if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

function parseJSON(value) {
    try {
        return JSON.parse(value)
    } catch (e) {
        return null
    }
}

const module = {

    state: {

        user: parseJSON(localStorage.getItem('user')),
        role: parseJSON(localStorage.getItem('role')),
        department: parseJSON(localStorage.getItem('department'))

    },

    mutations: {

        setUserData(state, userData) {

            state.user = userData.user
            state.role = userData.role
            state.department = userData.department

            localStorage.setItem('user', JSON.stringify(userData.user))
            localStorage.setItem('role', JSON.stringify(userData.role))
            localStorage.setItem('department', JSON.stringify(userData.department))
            localStorage.setItem('token', userData.token)

            axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
        },

        clearUserData(state) {

            state.user = null
            state.role = null
            state.department = null

            localStorage.removeItem('user')
            localStorage.removeItem('role')
            localStorage.removeItem('department')
            localStorage.removeItem('token')

            delete axios.defaults.headers.common.Authorization

            location.reload()
        }

    },

    actions: {
        async login({ commit }, credentials) {

            const { data } = await axios.post('/login', credentials)

            commit('setUserData', data)

            return data
        },

        async fetchUser({ commit }) {

            try {

                const { data } = await axios.get('/user')

                commit('setUserData', {
                    ...data,
                    token: localStorage.getItem('token')
                })

                return data

            } catch (error) {

                commit('clearUserData')

                throw error
            }

        },

        logout({ commit }) {

            commit('clearUserData')

        }
    },

    getters: {

        isLogged: () => !!localStorage.getItem('token'),

        user: state => state.user,

        role: state => state.role,

        department: state => state.department,

        roleName: state => state.role?.role_name || "",

        departmentName: state => state.department?.department_name || ""

    }

}

export default module